import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['prasymasTipas', 'appSavitarna']),
    prasymasTabs() {
      return {
        regPrasymasDuomenys: {
          title: this.$t('Dokumento duomenys'),
          route: this.isSavitarna ? this.$route.name : 'regPrasymasDuomenys',
          routeStep: 'asmenys',
          errorTab: 'ntrduomenys',
        },
        regPrasymasTeikejas: {
          title: this.$t('Duomenų teikėjas'),
          route: this.isSavitarna ? this.$route.name : 'regPrasymasTeikejas',
          routeStep: 'asmenys',
          errorTab: 'ntrteikejas',
        },
        regPrasymasAsmenys: {
          title: this.$t('Asmenys'),
          route: this.isSavitarna ? this.$route.name : 'regPrasymasAsmenys',
          routeStep: 'asmenys',
          errorTab: 'ntrasmenys',
        },
        regPrasymasAsmenysPirmenybe: {
          title: this.$t('Asmenys'),
          route: this.isSavitarna ? this.$route.name : 'regPrasymasAsmenys',
          routeStep: 'asmenys',
          errorTab: 'ntrasmenys',
        },
        regPrasymasTurtas: {
          title: this.$t('Nekilnojamasis turtas'),
          route: this.isSavitarna ? this.$route.name : 'regPrasymasTurtas',
          routeStep: 'turtas',
          errorTab: 'ntrturtas',
        },
        regPrasymasSutartis: {
          title: this.$t('Sutarties dok. duomenys'),
          route: this.isSavitarna ? this.$route.name : 'regPrasymasSutartis',
          routeStep: 'sutartis',
          errorTab: 'ntrsutartis',
        },
        regPrasymasRinkmenos: {
          title: this.$t('Rinkmenos'),
          route: this.isSavitarna ? this.$route.name : 'regPrasymasRinkmenos',
          routeStep: 'rinkmena',
          errorTab: 'ntrrinkmenos',
        },
        regPrasymasInformavimas: {
          title: this.$t('Informavimas'),
          route: this.isSavitarna
            ? this.$route.name
            : 'regPrasymasInformavimas',
          routeStep: 'informavimas',
          errorTab: 'ntrinformavimas',
        },
        regPrasymasRegistravimas: {
          title: this.$t('Registravimas'),
          route: this.isSavitarna
            ? this.$route.name
            : 'regPrasymasRegistravimas',
          routeStep: 'registravimas',
          errorTab: 'ntrregistravimas',
        },
      }
    },
    isSavitarna() {
      return this.appSavitarna
    },
  },
}
